import { createNewUser, saveRecordsEntidad} from './../../functions/src/index';
import { Injectable } from '@angular/core';
import { Observable, Observer, combineLatest, from } from 'rxjs';
import { Firestore,addDoc,doc ,setDoc, getDoc, deleteDoc,updateDoc, docData, query,Timestamp} from '@angular/fire/firestore';
import { collection, collectionGroup, DocumentData, getDocs, orderBy, Query, where } from 'firebase/firestore';
import { collectionData } from 'rxfire/firestore';
import { getFunctions, httpsCallable } from "firebase/functions";
import { FirebaseApp } from '@angular/fire/compat';
import { Storage, ref, list, getDownloadURL, getStorage} from '@angular/fire/storage';
import { switchMap, map, catchError } from 'rxjs/operators';
import { FirebasePaged } from './firebase-paged';

import * as firebase from 'firebase/compat/app';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { SigpacServiceService } from './sigpac-service.service';
import * as PolyUtil from 'google-maps-polyutil';

import { scrypt } from 'scrypt-js';
import { AuthFirebaseService } from './auth-firebase.service';
import moment from 'moment';
const INVITATION_PASSPHRASE = 'visorcue2025';

export interface Company {
  id: string;
  name: string;
  type: 'COMPANY' | 'ENTITY';
  size: string;
  email: string;
  postalAddress: string;
  postalCode: string;
  city: string;
  province: string;
  codCA: string;
  cif: string;
}

export interface RecintoImportacion {
  idsigpac: string;
  codCultivo: number;
  cultivo: string;
  codVariedad: number;
  variedad: string;
}

@Injectable({
  providedIn: 'root'
})

export class FirebaseRepositoryService {

  constructor(private firestore: Firestore,protected angularFire: FirebaseApp,
    private storage: Storage, private afs: AngularFirestore, private analytics: AngularFireAnalytics,
    public authService: AuthFirebaseService,
    private sigpacservice: SigpacServiceService) {


  }
  async acceptInvitation(hashInvitation: string) {

    //DEscodificamos el hash
    var ruta: string = await this.decrypt(hashInvitation,INVITATION_PASSPHRASE);
    return updateDoc(doc(this.firestore,ruta),'status','ACCEPTED');

  }

  premium:Boolean;

  userData:any;




  getUserByEmail(email: string) : Promise<any> {
    return new Promise((resolve,reject) => {
      this.searchUserByEmail(email).subscribe(resultado => {
        resolve(resultado);
      },error => {
        reject(error);
      })
    })
  }

  getUsersEntidad() : Observable<any> {
    var scope = this.authService.adminData.scope;
    return collectionData(query(collection(this.firestore,`users`),where('entidad','==',scope)),{idField:'id'});
  }

  getUserById(userId: string){
    return docData(doc(this.firestore,`users/${userId}`),{idField: 'id'});
  }

  searchUserByEmail(email: string) : Observable<any> {
    return collectionData(query(collection(this.firestore,`users`),where('email','==',email)),
     {idField: 'id'});
  }

  updateUser(usuario) : Promise<any> {
    return updateDoc(doc(this.firestore,`users/${usuario.id}`),usuario);
  }

  importREA(userid) : Promise<any> {

    return addDoc(collection(this.firestore,`users/${userid}/REACUERequest`),{
      type: 'REA',
      requestDate: Timestamp.now()
    });
  }

  async crearTarea(tarea) {
    const functions = getFunctions(this.angularFire,'europe-southwest1');

    const requestNewTask= httpsCallable(functions, 'crearTarea');
    try{
      let resultado = await requestNewTask(tarea);
      return resultado.data;
    }catch (error: any) {
      console.error('Error en createNewTask:', error);
      throw error;
    }

  }

  async createNewUser(usuario) {
    const functions = getFunctions(this.angularFire,'europe-southwest1');

    const requestNewUser = httpsCallable(functions, 'createNewUser');
    try{
       let resultado = await requestNewUser(usuario);
        return resultado.data;
    }catch (error: any) {
      console.error('Error en createNewUser:', error);
      throw error;
    }

  }

  async genCuePdfPreview(idUsuario) {
    const functions = getFunctions(this.angularFire,'europe-southwest1');

    const requestPdfPreview = httpsCallable(functions, 'genCuePdfPreview');
    try{
       let resultado = await requestPdfPreview({userid: idUsuario});
        return resultado.data;
    }catch (error: any) {
      console.error('Error en genCuePdfPreview:', error);
      throw error;
    }
  }

    async saveRecordsEntidad(registro) {
    const functions = getFunctions(this.angularFire,'europe-southwest1');

    const requestNewUser = httpsCallable(functions, 'saveRecordsEntidad');
    try{
    let resultado = await requestNewUser(registro);
    return resultado.data;
    }catch(error){
      console.log(error);
    }

  }

  async getStatsData(){
        const functions = getFunctions(this.angularFire,'europe-southwest1');

    const requestNewUser = httpsCallable(functions, 'getStatsData');
    try{
      let resultado = await requestNewUser({"types":["users","reacue"]});

      return resultado;
    }catch(error){
      console.log(error);
    }
    return [];
  }

  async changeAuthorizationStatus(registro) {
    const functions = getFunctions(this.angularFire,'europe-southwest1');

    const requesChangeState = httpsCallable(functions, 'cambiarEstadoAutorizacion');
    try{
      let resultado = await requesChangeState(registro);
      return resultado.data;
    }catch(error){
      console.log(error);
    }

  }

  getPendingAuthorizations() : Observable<any> {
    return collectionData(query(collection(this.firestore,`users`),where('reaCueAuthorized','==','PENDING')),
        {idField: 'id'});
  }


  getPendingAuthorizationsEntidad() : Observable<any> {
    var scope = this.authService.adminData.scope;

    return collectionData(query(collection(this.firestore,`users`),where('reaCueAuthorized','==','PENDING'),
    where('entidad','==',scope)),
        {idField: 'id'});
  }

  /**
   * Obtiene todas las autorizaciones pendientes con fecha de solicitud
   * Invoca: business-core.getPendingAuthorizationsWithDate
   */
  getPendingAuthorizationsWithDate(): Observable<any> {
    const functions = getFunctions(this.angularFire, 'europe-southwest1');
    const callable = httpsCallable(functions, 'getPendingAuthorizationsWithDate');

    console.log('[SERVICE_DEBUG] Calling getPendingAuthorizationsWithDate...');
    return from(callable({} as any)).pipe(
      map((response: any) => {
        console.log('[SERVICE_DEBUG] Got response from Cloud Function:', response);
        console.log('[SERVICE_DEBUG] Response type:', typeof response);
        console.log('[SERVICE_DEBUG] Response keys:', Object.keys(response));

        // Extraer el array correctamente
        let dataArray = response.data.data;
        if (!Array.isArray(dataArray)) {
          console.error('[SERVICE_ERROR] Response.data is not an array:', dataArray);
          dataArray = [];
        }
        console.log('[SERVICE_DEBUG] Final data array length:', dataArray.length);
        console.log('[SERVICE_DEBUG] Is array:', Array.isArray(dataArray));
        return dataArray;
      }),
      catchError(error => {
        console.error('[SERVICE_ERROR] Error fetching authorizations with date:', error);
        throw error;
      })
    );
  }

  /**
   * Obtiene autorizaciones pendientes de la entidad con fecha de solicitud
   * Invoca: business-core.getPendingAuthorizationsWithDate (con scope de entidad)
   */
  getPendingAuthorizationsEntityWithDate(): Observable<any> {
    const functions = getFunctions(this.angularFire, 'europe-southwest1');
    const callable = httpsCallable(functions, 'getPendingAuthorizationsWithDate');

    console.log('[SERVICE_DEBUG] Calling getPendingAuthorizationsEntityWithDate...');
    return from(callable({} as any)).pipe(
      map((response: any) => {
        console.log('[SERVICE_DEBUG] Got response from Cloud Function:', response);
        console.log('[SERVICE_DEBUG] Response type:', typeof response);
        console.log('[SERVICE_DEBUG] Response keys:', Object.keys(response));

        // Extraer el array correctamente
        let dataArray = response.data;
        if (!Array.isArray(dataArray)) {
          console.error('[SERVICE_ERROR] Response.data is not an array:', dataArray);
          dataArray = [];
        }
        console.log('[SERVICE_DEBUG] Final data array length:', dataArray.length);
        console.log('[SERVICE_DEBUG] Is array:', Array.isArray(dataArray));
        return dataArray;
      }),
      catchError(error => {
        console.error('[SERVICE_ERROR] Error fetching entity authorizations with date:', error);
        throw error;
      })
    );
  }

  async getAuthorizationUrl(uuid: string, fileRef?: string){
      console.log('[DEBUG_SERVICE] getAuthorizationUrl called with uuid:', uuid, 'fileRef:', fileRef);

      // Si hay un fileRef del backend, usarlo directamente
      if (fileRef) {
        console.log('[DEBUG_SERVICE] Using fileRef from backend:', fileRef);
        const storageRef = ref(this.storage, fileRef);
        const url = await getDownloadURL(storageRef);
        console.log('[DEBUG_SERVICE] Got URL from fileRef:', url);
        return url;
      }

      // Fallback: listar archivos en la carpeta
      console.log('[DEBUG_SERVICE] Falling back to list() in folder for uuid:', uuid);
      var folderRef = ref(this.storage, `REACUEAuths/${uuid}`);
      var listResult = await list(folderRef, {maxResults: 1});
      console.log('[DEBUG_SERVICE] List result items:', listResult.items);

      if (!listResult.items || listResult.items.length === 0) {
        console.error('[DEBUG_SERVICE] No files found in REACUEAuths/' + uuid);
        throw new Error('No authorization file found for user ' + uuid);
      }

      var lastDoc = listResult.items[0];
      const url = await getDownloadURL(lastDoc);
      console.log('[DEBUG_SERVICE] Got URL from list fallback:', url);
      return url;
  }

  async authorizeUser(uuid: string) {
    var userDoc = doc(this.firestore,`users/${uuid}`);
    await updateDoc(userDoc,{reaCueAuthorized:'AUTHORIZED'});
    if(this.authService.adminData.scope && this.authService.adminData.scope !== 'ALL') await this.importREA(uuid);
  }

   getReaCueRequests(email: string){


    return this.searchUserByEmail(email).pipe(switchMap(user =>
    {
      return collectionData(query(collection(this.firestore,`users/${user[0].id}/REACUERequest`),orderBy('requestDate','desc')),
      {idField: 'id'})
    }
      ));

  }

  getReaCueRequestsEntidad(){
    var scope = this.authService.adminData.scope;
    return collectionData(query(collectionGroup(this.firestore,`REACUERequest`),where('entidad','==',scope),orderBy('requestDate','desc')),{idField:'id'});
  }

  getReaCueRequestsId(idUser: string){
    return collectionData(query(collection(this.firestore,`users/${idUser}/REACUERequest`),orderBy('requestDate','desc')),
    {idField: 'id'})
  }

  async obtenerRegistros(email: string, selectedRegistros: any[]): Promise<FirebasePaged>{

    var filtros = [];
    var user = await this.getUserByEmail(email);
    console.log("Resultado de getUserByEmail:", user);

    if (!user || user.length === 0) {
      console.warn("No se encontró usuario para el email:", email);
      return null;
    }

    if(selectedRegistros != undefined && selectedRegistros != null && selectedRegistros.length > 0){
      filtros.push(where('recordType','in',selectedRegistros));

      }else{
        filtros.push(where('recordType','in',['SIEMBRA','FERTILIZACION','TRATAMIENTO','COSECHA','GEOFOTO']));
      }

    filtros.push(where('syncCUE.status', '!=', 'ADVISOR_DRAFT'));

    const userid = user?.[0]?.id ?? user;

      return new FirebasePaged(collection(this.firestore,`users/${userid}/records`), filtros, 3);

  }

  async obtenerRegistrosEntidad(userToSearch:any, selectedRegistros: any[]): Promise<FirebasePaged>{
    var scope = this.authService.adminData.scope;
    var filtros = [];
    filtros.push(where('entidad','==',scope));





    if(selectedRegistros != undefined && selectedRegistros != null && selectedRegistros.length > 0){
      filtros.push(where('recordType','in',selectedRegistros));

    }else{
      filtros.push(where('recordType','in',['SIEMBRA','FERTILIZACION','TRATAMIENTO','COSECHA','GEOFOTO']));
    }


    filtros.push(where('syncCUE.status', '!=', 'ADVISOR_DRAFT'));

    if(userToSearch){
      filtros.push(where('userAuthor','==',userToSearch.id));
    }


      return new FirebasePaged(collectionGroup(this.firestore,`records`), filtros, 3);

  }

  async obtenerRegistrosId(userId: string, selectedRegistros: any[]): Promise<FirebasePaged>{

    var filtros = [];

    if(selectedRegistros != undefined && selectedRegistros != null && selectedRegistros.length > 0){
      filtros.push(where('recordType','in',selectedRegistros));

    }else{
          filtros.push(where('recordType','in',['SIEMBRA','FERTILIZACION','TRATAMIENTO','COSECHA','GEOFOTO']));
    }

    filtros.push(where('syncCUE.status', '!=', 'ADVISOR_DRAFT'));

    return new FirebasePaged(collection(this.firestore,`users/${userId}/records`), filtros, 3);

  }

  obtenerRegistro(userId: string, recordId: string) {
    const ref = doc(this.firestore, `users/${userId}/records/${recordId}`);
    return docData(ref, { idField: 'id' });
  }

  async obtenerOrdenTratamiento(userId: string, ordentratamientoId: string) {
    const ref = collection(this.firestore, `users/${userId}/records`);
    const q = query(ref, where('syncCUE.requirementRef', '==', ordentratamientoId));
    const qs = await getDocs(q);
    if (qs.empty) return undefined;
    const d = qs.docs[0];
    return { ...d.data(), id: d.id };
  }



  obtenerOrdenesEntidad(): Observable<any[]> {
    const scope = this.authService.adminData.scope;

    const q = query(
      collectionGroup(this.firestore, 'records'),
      where('entidad', '==', scope),
      where('recordType', '==', 'ORDEN_TRATAMIENTO')
    );

    return collectionData(q, { idField: 'id' });
  }

  obtenerStock(){
    var scope = this.authService.adminData.scope;
    return collectionData(query(collectionGroup(this.firestore,`stock`),where('entidad','==',scope)),{idField:'id'})
  }

  obtenerMovimientosStock(userId: string, stockId: string){
    return collectionData(collection(this.firestore,`users/${userId}/stock/${stockId}/movements`),{idField:'id'})
  }

  obtenerParcelas(email: string){


    return this.searchUserByEmail(email).pipe(switchMap(user =>
      {
        return collectionData(collection(this.firestore,`users/${user[0].id}/fields`),{idField:'id'})
      }
        ));

  }

  obtenerParcelasEntidad(){
      var scope = this.authService.adminData.scope;


        return collectionData(query(collectionGroup(this.firestore,`fields`),where('entidad','==',scope)),{idField:'id'})


  }

  obtenerParcelasId(userId: string){
    return collectionData(collection(this.firestore,`users/${userId}/fields`),{idField:'id'})
  }
  obtenerPacela(userId: string, idParcela: string) {
    return docData(doc(this.firestore,`users/${userId}/fields/${idParcela}`),{idField:'id'})
  }

  private observableToPromise<T>(observable: Observable<T>) : Promise<T>{
    return new Promise((resolve,reject) =>{
      observable.subscribe(result =>{
          resolve(result);
      },error => {
        reject(error);
      })
    })
  }

  getUser():Observable<any>{
      return new Observable((observer) => {

        this.angularFire.auth().onAuthStateChanged((user) => {


          if(user == null) {
           // console.log("Desactivamos premium")
            this.premium = null;
            this.userData = null;
          }

          if(user != null && this.userData == null){
            this.updateUserData(observer);
          }else{
            observer.next(user);
          }


        });


        observer.next(firebase.default.auth().currentUser);

      });
    }

  updateUserData(observer: Observer<any>){
    let userid = this.angularFire.auth().currentUser.uid;
    let docReference =  doc(this.firestore,`users/${userid}`);
    docData(docReference).subscribe(v => {
      console.log("UserData actualizado");
      this.userData = v;
      console.log(this.userData);
      observer.next(this.angularFire.auth().currentUser);
    });
  }

  obtenerSeasons():Observable<any> {
    return new Observable((observer) => {
      this.afs.collection('users').doc(this.angularFire.auth().currentUser.uid).collection('seasons').get().subscribe((snapshot)=>{
        let seasons = [];
        snapshot.forEach((doc)=>{
          let registro = JSON.parse(JSON.stringify(doc.data()));
          registro.id = doc.id;


          seasons.push(registro);
        })
        observer.next(seasons);
      });
    });
  }

  obtenerDiario(idUsuario: string, idParcela: string)  :Observable<any>{
    this.analytics.logEvent('obtener_diario')
    return collectionData(query(collection(this.firestore,`users/${idUsuario}/records`),where('fieldReference','==',idParcela)),{idField:'id'});


  }

  obtenerParcelasEnConsultaRegistros() : Observable<any>{
    this.analytics.logEvent('obtener_parcelas')
    return new Observable((observer) => {
      let userid = this.angularFire.auth().currentUser.uid;

      //Tenenmos que comprobar si el usuario es admin o no
      let fieldsCollection: Query<DocumentData>;
      fieldsCollection = collection(this.firestore,`users/${userid}/fields`);

      collectionData(fieldsCollection, {idField: 'id'}).subscribe(async (doc) => {

        for(let parcela of doc){
          if(parcela.path != null){

            //console.log("Generamos geometria")
            parcela.geometry = this.generateGeometry(parcela.path);
            //console.log(parcela.geometry);

          }else{
            //console.log("Obtenemos geometria SIGPAC")
            const parcelasigpac = await this.sigpacservice.getParcela(parcela.params);
            parcela.geometry = parcelasigpac.geometry;
            //console.log(parcelasigpac);
          }

          this.generateParcelaParams(parcela);
        }

        console.log('hemos terminado de tratar los datos');
        observer.next(doc);
     });

    });

  }

  generateParcelaParams(parcela: any) {
      let parcParams = parcela.params.split(',');
      parcela.codProvincia = parcParams[0];
      parcela.codMunicipio = parcParams[1];
      parcela.agregado = parcParams[2];
      parcela.zona = parcParams[3];
      parcela.poligono = parcParams[4];
      parcela.parcela = parcParams[5];
      parcela.recinto = parcParams[6];
    }

    generateGeometry(path: string):any{
      let geometry = {
        type:'Polygon',
        coordinates:[[]],

      }

      if(path.split("|").length > 2){
        //Es iOS

        try{
          path.split("|").forEach((coord) => {
            let cp = coord.split(':');
            if (cp.length != 2){
              throw new Error(('No se puede generar coordenadas'));
            }
            geometry.coordinates[0].push([Number(cp[1]),Number(cp[0])]);
          })
        } catch(e) {
          let coords = PolyUtil.decode(path).reverse();
          coords.forEach((coordp) => {

            geometry.coordinates[0].push([coordp.longitude,coordp.latitude])
          });
        }
      } else {
        let coords = PolyUtil.decode(path).reverse();
        coords.forEach((coordp) => {

          geometry.coordinates[0].push([coordp.longitude,coordp.latitude])
        });
      }




      return geometry;
    }

  actualizaRegistroDiario(idParcela:string, diario: any) :Observable<any>{
    this.analytics.logEvent('actualizar_registro_diario')
    return new Observable((observer)=>{
        let idRegistro = diario.id;
        delete diario.id;
        diario.cantidad = +Number(diario.cantidad)
        diario.afectado = +Number(diario.afectado)
        this.afs.collection('users').doc(this.angularFire.auth().currentUser.uid).collection('fields').doc(idParcela)
      .collection('records').doc(idRegistro).update(diario).then((updated)=>{
        observer.next(updated);
      });
    });
  }

  checkPremium():Observable<Boolean>{
    return new Observable((observer) => {
        if(this.premium != null){
          observer.next(this.premium);
        }else{
          this.afs.collection('users').doc(this.angularFire.auth().currentUser.uid).ref.get().then((doc) => {
            this.premium = (doc.data() as any).premium;
            observer.next(this.premium);
        });
        }
    });
    }

    creaRegistroDiario(idParcela:string,diario: any) :Observable<any>{
      this.analytics.logEvent('crear_registro_diario')
      return new Observable((observer)=>{
        diario.cantidad = Number(diario.cantidad)
        diario.afectado = Number(diario.afectado)
          this.afs.collection('users').doc(this.angularFire.auth().currentUser.uid).collection('fields').doc(idParcela)
        .collection('records').add(diario).then((diarioCreated) => {
          diario.id = diarioCreated.id;
          observer.next(diario);
        });
      });
    }

    eliminarRegistroDiario(idParcela:string,idRegistro: string) :Observable<any>{
      this.analytics.logEvent('emliminar_registro_diario')
      return new Observable((observer) => {
        this.afs.collection('users').doc(this.angularFire.auth().currentUser.uid).collection('fields').doc(idParcela)
        .collection('records').doc(idRegistro).delete().then((confirmed) =>{
            observer.next(confirmed);
        });
      });
    }

    updateParcela(p: any):Observable<any>{
      return new Observable((observer) => {
        var pid = p.id;
        delete p.id;
        var docRef = this.afs.collection('users').doc(this.angularFire.auth().currentUser.uid).collection('fields').doc(pid);

        docRef.update(p).then((exito) => {
            observer.next(exito);
        });
      });
    }

    eliminarRegistro(idUsuario: string, idRegistro: string): Promise<any>{

      let docReference = doc(this.firestore,`users/${idUsuario}/records/${idRegistro}`);
      if(this.userData && this.userData.reaCueAuthorized && this.userData.reaCueAuthorized == 'AUTHORIZED'){
        return updateDoc(docReference,'syncCUE.status','INIT_DELETE');
      } else {
        return deleteDoc(docReference);
      }

    }

    guardarRegistro(registro: any):Promise<any>{
      let userid = registro.userAuthor;
      let registroId = registro.id;
      delete registro.id;
      registro.syncCUE.status = 'INIT';

      let docReference = doc(this.firestore,`users/${userid}/records/${registroId}`);
     return updateDoc(docReference,registro);
    }

  obtenerParcela(fieldReference: any): Observable<any> {
    let userid = this.angularFire.auth().currentUser.uid;
    let docReference =  doc(this.firestore,`users/${userid}/fields/${fieldReference}`);
    return docData(docReference);
  }

  obtenerMaquinaria() : Observable<any> {
    let userid = this.angularFire.auth().currentUser.uid;
     return collectionData(collection(this.firestore,`users/${userid}/machinery`), {idField: 'identifier'});
  }

  obtenerAsesoresAplicadores() : Observable<any> {
    let userid = this.angularFire.auth().currentUser.uid;
     return collectionData(collection(this.firestore,`users/${userid}/advisorsappliers`), {idField: 'identifier'});
  }

  obtenerAvisos() : Observable<any> {
    var scope = this.authService.adminData.scope;
    return collectionData(query(collection(this.firestore,`announcements`),where('entidad','==',scope)),{idField:'id'});
  }

  obtenerTareas() : Observable<any> {
    var scope = this.authService.adminData.scope;
    return collectionData(query(collection(this.firestore,`tasks`),where('entidad','==',scope)),{idField:'id'});
  }

  borrarAviso(idAviso: string): Promise<any>{
    let docReference = doc(this.firestore,`announcements/${idAviso}`);
    if(docReference){
      return deleteDoc(docReference);
    }
  }

  getGeofoto(registro: any): Promise<string>{
    let currentUserId = this.angularFire.auth().currentUser?.uid;
    const pathReference = ref(getStorage(), `users/${currentUserId}/${registro.recordData.imageName}`);
    return getDownloadURL(pathReference);
  }

  guardarAviso(aviso: any):Promise<any>{

    aviso.timestamp = Timestamp.now();
    // SOLO asignar entidad si no viene informada
    aviso.entidad ??= this.authService.adminData.scope;
    aviso.author = this.authService.adminData.id;
    if(aviso.planned_timestamp && aviso.planned_timestamp != ''){
      aviso.planned_timestamp = Timestamp.fromDate(moment(aviso.planned_timestamp,'DD/MM/YYYY hh:mm:ss').toDate())

    }else{
      aviso.planned_timestamp = Timestamp.now();
    }
    aviso.status = 'SCHEDULED';
     return addDoc(collection(this.firestore,`announcements`),aviso);

  }


  actualizarAviso(aviso: any):Promise<any>{
    let docReference = doc(this.firestore,`announcements/${aviso.id}`);
    if(aviso.planned_timestamp && aviso.planned_timestamp != ''){
      aviso.planned_timestamp = Timestamp.fromDate(moment(aviso.planned_timestamp,'DD/MM/YYYY hh:mm:ss').toDate())
    }else{
      aviso.planned_timestamp = Timestamp.now();
    }
    return updateDoc(docReference,aviso);
  }

  private hexToUint8Array(hex: string): Uint8Array {
    if (hex.length % 2 !== 0) throw new Error("Hex string must have even length");
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < hex.length; i += 2) {
      bytes[i / 2] = parseInt(hex.substring(i, i + 2), 16);
    }
    return bytes;
  }

  private async decrypt(encryptedText: string, passphrase: string): Promise<string> {
    const [ivHex, encryptedHex] = encryptedText.split(':');
    const iv = this.hexToUint8Array(ivHex);
    const encrypted = this.hexToUint8Array(encryptedHex);

    const salt = new TextEncoder().encode('salt'); // debe coincidir con la usada en el backend
    const N = 16384, r = 8, p = 1, dkLen = 32;

    const passphraseBytes = new TextEncoder().encode(passphrase);

    const key = await scrypt(passphraseBytes, salt, N, r, p, dkLen);

    const cryptoKey = await crypto.subtle.importKey(
      'raw',
      key,
      { name: 'AES-CTR' },
      false,
      ['decrypt']
    );

    const decryptedBuffer = await crypto.subtle.decrypt(
      {
        name: 'AES-CTR',
        counter: iv,
        length: 64,
      },
      cryptoKey,
      encrypted
    );

    return new TextDecoder().decode(decryptedBuffer);
  }

  async actualizarStock(updateRequest: any) {
    const functions = getFunctions(this.angularFire,'europe-southwest1');
    const fn = httpsCallable(functions, 'realizarAprovisionamiento');
    try{
      let resultado = await fn(updateRequest);
      return resultado.data;
    }catch (error: any) {
      console.error('Error en realizarAprovisionamiento:', error);
      throw error;
    }
  }

  // Obtener entidades / empresas
  getCompanies(): Observable<any> {
    return collectionData(
      query(collection(this.firestore, 'companies')),
      { idField: 'id' }
    );
  }

  async autoRegistroEntidad(company: any): Promise<any> {
    const functions = getFunctions(this.angularFire,'europe-southwest1');
    const fn = httpsCallable(functions, 'autoRegistroEntidad');
    try {
      const resultado = await fn(company);
      return resultado.data;
    } catch (error: any) {
      console.error('Error en autoRegistroEntidad:', error);
      throw error;
    }
  }

  // Crear nueva entidad / empresa
  createCompany(company: any): Promise<any> {
    const { id, ...data } = company;
    return addDoc(collection(this.firestore, 'companies'), data);
  }

  // Actualizar entidad / empresa
  updateCompany(company: any): Promise<any> {
    const { id, ...data } = company;
    const docReference = doc(this.firestore, `companies/${id}`);
    return updateDoc(docReference, data);
  }

  getCompanyById(companyId: string){
    return docData(doc(this.firestore,`companies/${companyId}`),{idField: 'id'});
  }

  obtenerTaxonomies(): Observable<any> {
    const scope = this.authService.adminData.scope;

    const taxRef = collection(this.firestore, 'taxonomies');

    const q = query(
      taxRef,
      where('type', '==', 'TASK_TYPE'),
      where('entidad', 'in', ['ALL', scope])
    );

    return collectionData(q, { idField: 'id' });
  }

  getWorkersEntidad(): Observable<any> {
    const scope = this.authService.adminData.scope;

    const usersRef = collection(this.firestore, 'users');

    const q = query(
      usersRef,
      where('entidad', '==', scope),
      where('rolEntidad', '==', 'WORKER')
    );

    return collectionData(q, { idField: 'id' });
  }

  async assignTask(updateRequest: any) {
    const functions = getFunctions(this.angularFire,'europe-southwest1');
    const fn = httpsCallable(functions, 'asignarTarea');
    try{
      let resultado = await fn(updateRequest);
      return resultado.data;
    }catch (error: any) {
      console.error('Error en asignarTarea', error);
      throw error;
    }
  }

  confirmarAutorizacion(idowner: string): Observable<any> {

    const functions = getFunctions(this.angularFire,'europe-southwest1');
    const callable = httpsCallable(functions, 'confirmarAutorizacion');

    console.log('[SERVICE_DEBUG] Calling confirmarAutorizacion...', idowner);

    return from(
      callable({
        idowner: idowner
      })
    ).pipe(

      map((response: any) => {
        console.log('[SERVICE_DEBUG] Response confirmarAutorizacion:', response);
        return response.data;
      }),

      catchError(error => {
        console.error('[SERVICE_ERROR] Error confirmarAutorizacion:', error);
        throw error;
      })
    );
  }

  descargarModelo(idowner: string): Observable<any> {

    const functions = getFunctions(this.angularFire,'europe-southwest1');
    const callable = httpsCallable(functions, 'descargarModeloAutorizacion');

    console.log('[SERVICE_DEBUG] Calling descargarModelo...', idowner);

    return from(
      callable({
        idowner: idowner
      })
    ).pipe(

      map((response: any) => {
        console.log('[SERVICE_DEBUG] Response descargarModelo:', response);
        return response.data;
      }),

      catchError(error => {
        console.error('[SERVICE_ERROR] Error descargarModelo:', error);
        throw error;
      })
    );
  }

  enviarAutorizacion(file: string, idowner: string): Observable<any> {

    const functions = getFunctions(this.angularFire,'europe-southwest1');
    const callable = httpsCallable(functions, 'enviarAutorizacion');

    console.log('[SERVICE_DEBUG] Calling enviarAutorizacion...',
      {
        idowner: idowner,
        fileLength: file?.length
      }
    );

    return from(
      callable({
        file: file,
        idowner: idowner
      })
    ).pipe(

      map((response: any) => {
        console.log('[SERVICE_DEBUG] Response enviarAutorizacion:', response);
        return response.data;
      }),

      catchError(error => {
        console.error('[SERVICE_ERROR] Error enviarAutorizacion:', error);
        throw error;
      })
    );
  }

  importarRecintos(idowner: string, recintos: RecintoImportacion[]): Observable<any> {

    const functions = getFunctions(this.angularFire,'europe-southwest1');
    const callable = httpsCallable(functions, 'importarRecintos');

    console.log('[SERVICE_DEBUG] Calling importarRecintos...',
      {
        idowner,
        recintos
      }
    );

    return from(
      callable({
        idowner: idowner,
        recintos: recintos
      })
    ).pipe(

      map((response: any) => {
        console.log('[SERVICE_DEBUG] Response importarRecintos:', response);
        return response.data;
      }),

      catchError(error => {
        console.error('[SERVICE_ERROR] Error importarRecintos:', error);
        throw error;
      })
    );
  }

  eliminarRecinto(datos: {idowner: string, id: string}): Observable<any> {

    const functions = getFunctions(this.angularFire,'europe-southwest1');
    const callable = httpsCallable(functions, 'eliminarRecinto');

    console.log('[SERVICE_DEBUG] Calling eliminarRecinto...', datos);

    return from(
      callable(datos)
    ).pipe(

      map((response: any) => {
        console.log('[SERVICE_DEBUG] Response eliminarRecinto:', response);
        return response.data;
      }),

      catchError(error => {
        console.error('[SERVICE_ERROR] Error eliminarRecinto:', error);
        throw error;
      })

    );
  }

  modificarRecinto(datos: {idowner: string, id: string, codCultivo: number, cultivo: string, codVariedad: number, variedad: string, codigoDGC: string, alias: string}): Observable<any> {

    const functions = getFunctions(this.angularFire,'europe-southwest1');
    const callable = httpsCallable(functions, 'modificarRecinto');

    console.log('[SERVICE_DEBUG] Calling modificarRecinto...', datos);

    return from(
      callable(datos)
    ).pipe(

      map((response: any) => {
        console.log('[SERVICE_DEBUG] Response modificarRecinto:', response);
        return response.data;
      }),

      catchError(error => {
        console.error('[SERVICE_ERROR] Error modificarRecinto:', error);
        throw error;
      })

    );
  }

}


